import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clock\">\r\n<circle cx=\"7\" cy=\"7\" r=\"6.5\" stroke=\"#696974\" />\r\n<path d=\"M7 4L7 8\" stroke=\"#696974\" stroke-linecap=\"round\" />\r\n<path d=\"M10 8.5C10.2761 8.5 10.5 8.27614 10.5 8C10.5 7.72386 10.2761 7.5 10 7.5V8.5ZM10 7.5H7V8.5H10V7.5Z\" fill=\"#696974\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol